import React from 'react';
import { SupervisionComplianceReport as SupervisionComplianceReportData } from '../../models/Report';
import { ExportDropdown } from './ExportDropdown';
import { rowsToCsv, downloadCsv, todayStamp } from '../../utils/csv';

interface Props {
  data: SupervisionComplianceReportData;
  onBack?: () => void;
}

export const SupervisionComplianceReport: React.FC<Props> = ({ data }) => {
  const handleExportCSV = () => {
    const csv = rowsToCsv(data.supervisionByRBT, [
      { header: 'RBT Name', get: (r) => r.rbtName },
      { header: 'Total Sessions', get: (r) => r.totalSessions },
      { header: 'Supervised Sessions', get: (r) => r.supervisedSessions },
      { header: 'Compliance Rate (%)', get: (r) => r.complianceRate },
      { header: 'Total Supervision Minutes', get: (r) => r.totalSupervisionMinutes },
    ]);
    downloadCsv(`supervision-compliance_${todayStamp()}.csv`, csv);
  };

  return (
  <div>
    {/* Toolbar */}
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'var(--spacing-4)' }}>
      <ExportDropdown onExportCSV={handleExportCSV} />
    </div>

    <div className="grid grid-cols-3" style={{ gap: 'var(--spacing-4)', marginBottom: 'var(--spacing-6)' }}>
      <div className="card">
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
          Compliance Rate
        </div>
        <div style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)', color: 'var(--color-success)' }}>
          {data.complianceRate}%
        </div>
      </div>
      <div className="card">
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
          Supervised Sessions
        </div>
        <div style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)' }}>
          {data.supervisedSessions}
        </div>
      </div>
      <div className="card">
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
          Total Requiring Supervision
        </div>
        <div style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)' }}>
          {data.totalSessionsRequiringSupervision}
        </div>
      </div>
    </div>

    <div className="card">
      <h3 style={{ marginBottom: 'var(--spacing-4)' }}>Supervision by RBT</h3>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>RBT Name</th>
              <th>Total Sessions</th>
              <th>Supervised</th>
              <th>Compliance Rate</th>
              <th>Total Minutes</th>
            </tr>
          </thead>
          <tbody>
            {data.supervisionByRBT.map((rbt) => (
              <tr key={rbt.rbtId}>
                <td>{rbt.rbtName}</td>
                <td>{rbt.totalSessions}</td>
                <td>{rbt.supervisedSessions}</td>
                <td>
                  <span
                    style={{
                      color:
                        rbt.complianceRate >= 80
                          ? 'var(--color-success)'
                          : 'var(--color-warning)',
                    }}
                  >
                    {rbt.complianceRate}%
                  </span>
                </td>
                <td>{rbt.totalSupervisionMinutes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
  );
};
